const { h, render, Component } = require('preact');

class Quantity extends Component {
  constructor(props) {
    super(props);
    this.findGrouponQuantity = this.findGrouponQuantity.bind(this);
  }

  findGrouponQuantity(orderDetails){
    let quantity = 0;
    if (orderDetails && orderDetails.groupons && orderDetails.groupons.length > 0){
      orderDetails.groupons.forEach(function(groupon){
        if (groupon.availability && groupon.availability.toLowerCase() !== "refunded" && groupon.purchaseStatus && groupon.purchaseStatus.toLowerCase() !== "refunded"){
          quantity++;
        }
      });
    }
    return quantity;
  }

  render() {
    return (
      <tr>
        <td>{I18n.translate("js.modules.support.qty")}</td>
        <td>{this.findGrouponQuantity(this.props.orderDetails)}</td>
      </tr>
    );
  }
}
module.exports = Quantity
